import { Box, Typography } from '@mui/material'
import type { CandidateNote as CandidateNoteType } from 'recruiter/graphql/candidateNotes.gql'

import NoteListItem from './NoteListItem'

interface NoteListPanelProps {
    notes: CandidateNoteType[]
    selectedNoteId: string | null
    onSelectNote: (note: CandidateNoteType) => void
}

const NoteListPanel = ({
    notes,
    selectedNoteId,
    onSelectNote,
}: NoteListPanelProps) => {
    if (notes.length === 0) {
        return (
            <Box
                sx={{
                    width: 340,
                    flexShrink: 0,
                    borderRight: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="body1" color="text.secondary">
                    No notes found
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={{
                width: 340,
                flexShrink: 0,
                borderRight: '1px solid',
                borderColor: 'divider',
                overflowY: 'auto',
            }}
        >
            {notes.map((note) => (
                <NoteListItem
                    key={note.noteId}
                    note={note}
                    isSelected={note.noteId === selectedNoteId}
                    onClick={() => onSelectNote(note)}
                />
            ))}
        </Box>
    )
}

export default NoteListPanel
